import { render, staticRenderFns } from "./BetaBadge.vue?vue&type=template&id=46b90eca&scoped=true"
import script from "./BetaBadge.vue?vue&type=script&lang=js"
export * from "./BetaBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46b90eca",
  null
  
)

export default component.exports